import DateFilterService from '../../../services/date-filter-service';

/**
 * Top winnings model
 */
export default class TopWinningsItemModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * betslip ID
     * @type {number}
     */
    this.betslipId = data.id;
    /**
     * Stake amount
     * @type {string}
     */
    this.stake = data.s;
    /**
     * Date
     * @type {sting}
     */
    // eslint-disable-next-line no-undef
    this.date = DateFilterService.localDate(data.d, 'date', APP_SETTINGS.formatting.shortDateFormat, '', false);
    /**
     * Payout amount
     * @type {string}
     */
    this.payout = data.p;
    /**
     * Currency symbol
     * @type {string}
     */
    this.currency = data.c;
    /**
     * Username
     */
    this.username = data.u;
  }
}
